export default __webpack_public_path__ + "static/media/10.7e4b2dd5.jpg";